import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { COMPANY } from "@/data/site";

const NAV_LINKS = [
  { label: "Products", href: "#products" },
  { label: "Capabilities", href: "#capabilities" },
  { label: "Floor", href: "#floor" },
  { label: "Industries", href: "#industries" },
  { label: "Contact", href: "#quote" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 border-b ${
        scrolled
          ? "bg-[#F5F1EA]/80 backdrop-blur-xl border-white/5"
          : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 h-16 md:h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-logo"
          className="flex items-center gap-2.5 group"
        >
          <img
            src="/logo/tavas-mark.png"
            alt="Tavas"
            className="h-8 w-auto md:h-9 transition-transform duration-300 group-hover:-rotate-3"
          />
          <span className="font-display font-800 tracking-tighter text-lg leading-none">
            TAVAS<span className="text-[#0055FF]">.</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-mono-tech text-[11px] uppercase tracking-widest text-[#55524B] hover:text-[#0F172A] link-underline pb-1"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#quote"
          data-testid="nav-cta"
          className="hidden md:inline-flex btn-industrial items-center gap-2 bg-[#0055FF] hover:bg-[#3377FF] text-white text-[12px] font-mono-tech uppercase tracking-widest px-5 py-2.5"
        >
          Request Quote
        </a>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((o) => !o)}
          className="md:hidden flex flex-col gap-1.5 p-2"
          aria-label="Toggle menu"
        >
          <span className={`h-px w-6 bg-[#0F172A] transition-transform ${open ? "translate-y-[7px] rotate-45" : ""}`} />
          <span className={`h-px w-6 bg-[#0F172A] transition-opacity ${open ? "opacity-0" : ""}`} />
          <span className={`h-px w-6 bg-[#0F172A] transition-transform ${open ? "-translate-y-[7px] -rotate-45" : ""}`} />
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="md:hidden bg-[#F5F1EA]/95 backdrop-blur-xl border-t border-white/5 px-5 py-6 flex flex-col gap-4">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="font-mono-tech text-xs uppercase tracking-widest text-[#55524B] hover:text-[#0F172A]"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#quote"
            onClick={() => setOpen(false)}
            className="btn-industrial bg-[#0055FF] text-white text-xs font-mono-tech uppercase tracking-widest px-5 py-3 text-center mt-2"
          >
            Request Quote
          </a>
        </div>
      )}
    </header>
  );
};
